/**
 * A global namespace for `transitionProperty` string for modern browsers.
 */
const transitionProperty = 'transitionProperty';
export default transitionProperty;
